module.exports = __webpack_public_path__ + "static/media/base.dc699a64.png";